export const selectSettings = state => state.settings

export const selectSettingsData = state => state.settings
